import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

const getPMFSurveyUrl = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'yola-editor.pmf-survey.url');
  }

  return get(cfg, 'yola-editor.pmf-survey.wl_url');
};

export default getPMFSurveyUrl;
